import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import PublicLayout from "@/components/PublicLayout";
import PublicHome from "@/pages/public/Home";
import PublicProdutos from "@/pages/public/Produtos";
import PublicContato from "@/pages/public/Contato";
import PublicOrcamento from "@/pages/public/Orcamento";

import Login from "@/pages/Login";
import CrmLayout from "@/components/CrmLayout";
import Dashboard from "@/pages/crm/Dashboard";
import Funil from "@/pages/crm/Funil";
import Producao from "@/pages/crm/Producao";
import Clientes from "@/pages/crm/Clientes";
import Orcamentos from "@/pages/crm/Orcamentos";
import Tarefas from "@/pages/crm/Tarefas";
import Conversas from "@/pages/crm/Conversas";
import Produtos from "@/pages/crm/Produtos";
import Configuracoes from "@/pages/crm/Configuracoes";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#07090E] flex items-center justify-center text-slate-400">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<PublicHome />} />
            <Route path="/produtos" element={<PublicProdutos />} />
            <Route path="/contato" element={<PublicContato />} />
            <Route path="/orcamento" element={<PublicOrcamento />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<Protected><CrmLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="funil" element={<Funil />} />
            <Route path="producao" element={<Producao />} />
            <Route path="leads" element={<Navigate to="/app/funil" replace />} />
            <Route path="oportunidades" element={<Navigate to="/app/funil" replace />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="orcamentos" element={<Orcamentos />} />
            <Route path="tarefas" element={<Tarefas />} />
            <Route path="conversas" element={<Conversas />} />
            <Route path="produtos" element={<Produtos />} />
            <Route path="configuracoes" element={<Configuracoes />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
